import styled from 'react-emotion';

import { DialogContent as BaseDialogContent } from '../../common/Dialog';

export default styled(BaseDialogContent)`
  margin-bottom: 20px;
`;
